import React, { useState, useEffect } from 'react'
import {
  IonGrid,
  IonRow,
  IonSelect,
  IonSelectOption
} from '@ionic/react'
import { ChapterCard } from '../../../components/common/ChapterCard'
import './styles.scss'

const RadioBody = (props) => {
  const { product } = props
  const [activeSeason, setActiveSeason] = useState([])
  const [selectedSeason, setSelectedSeason] = useState(0)
  const [seasons, setSeasons] = useState([])

  useEffect(() => {
    if (typeof product !== 'undefined') {
      const index = product.contents.length - 1
      setSeasons(product.contents)
      setSelectedSeason(index)
      setActiveSeason(product.contents[index].content.reverse())
    }
  }, [product])

  useEffect(() => {
    if (seasons.length > 0) {
      setActiveSeason(seasons[selectedSeason].content.reverse())
    }
  }, [seasons, selectedSeason])

  return (
    <div className='radio-body'>
      <section className='season-selector'>
        <IonSelect interface='popover' value={selectedSeason} placeholder='Seleccionar Temporada' onIonChange={e => setSelectedSeason(e.detail.value)}>
          {seasons.map((season, index) => (
            <IonSelectOption key={index} value={index}>{season.serial}</IonSelectOption>
          ))}
        </IonSelect>
      </section>
      <IonGrid>
        <IonRow>
          {activeSeason.map((chapter) => (
            <ChapterCard key={chapter.id_content} chapter={chapter} />
          ))}
        </IonRow>
      </IonGrid>
    </div>
  )
}

export default RadioBody
